import request from '@/request/request'

/**
 * 经济类型字典查询
 * @returns 
 */
export function initEconomicType () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/economicType',
    method: 'get',
  })
}

/**
 * 币种字典查询
 * @returns 
 */
export function initCurrency () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/currency',
    method: 'get',
  })
}

/**
 * 权证类型查询
 * @returns 
 */
export function initPropertyType () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/propertyType',
    method: 'get',
  })
}

/**
 * 权证类型其他-标签
 * @returns 
 */
export function initLabel () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/label',
    method: 'get',
  })
}

/**
 * 获取位置省份列表
 * @returns 
 */
export function initProvinceList () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/provinceList',
    method: 'get',
  })
}

/**
 * 所属地段
 * @returns 
 */
export function initDistrict () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/district',
    method: 'get',
  })
}

/**
 * 所属板块
 * @returns 
 */
export function initBlock () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/block',
    method: 'get',
  })
}

/**
 * 权利人类型
 * @returns 
 */
export function initObligeeType () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/obligeeType',
    method: 'get',
  })
}

/**
 * 房屋状态
 * @returns 
 */
export function initHouseStatus () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/houseStatus',
    method: 'get',
  })
}

/**
 * 租赁用途
 * @returns 
 */
export function initLeaseUseType () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/leaseUseType',
    method: 'get',
  })
}

/**
 * 公开招租列表项目状态筛选项字典

 * @returns 
 */
export function initBidApplyProjectOption () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/bidApplyProjectOption',
    method: 'get',
  })
}

/**
 * 意向招租列表项目状态筛选项字典
 * @returns 
 */
export function initIntentLeaseProjectType () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/intentLeaseProjectType',
    method: 'get',
  })
}

/**
 * 国家字典
 * @returns 
 */
export function initCountry () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/country',
    method: 'get',
  })
}

/**
 * 商业细分业态-业务字典
 * @returns 
 */
export function initBusinessCategories () {
  return request({
    url: 'https://api.jssyjt.net/external-service-center/initShexgrpDictionaries/businessCategories',
    method: 'get',
  })
}

/**
 * 园区细分业态-业务字典
 * @returns 
 */
export function initParkCategories () {
  return request({
    url: 'https://api.jssyjt.net/external-service-center/initShexgrpDictionaries/parkCategories',
    method: 'get',
  })
}

/**
 * 所属集团企业树
 * @returns 
 */
export function initOrgTree () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/orgTree',
    method: 'get',
  })
}

/**
 * 国资监管企业列表
 * @returns 
 */
export function initOrgList () {
  return request({
    url: '/external-service-center/initShexgrpDictionaries/orgList',
    method: 'get',
  })
}

